// extracted by mini-css-extract-plugin
module.exports = {"body":"styles_body__1DCUG","icon":"styles_icon__2vSWA"};